<script setup lang="ts">
import type { PassengerType } from '@optionway/models';

const prefix = 'components.search.passengersTypes';

const adults = defineModel<PassengerType['adults']>('adults', { default: 0 });
const children = defineModel<PassengerType['children']>('children', { default: 0 });
const infants = defineModel<PassengerType['infants']>('infants', { default: 0 });

defineProps<{ separator?: boolean }>();

const searchCriteria = useSearchCriteriaStore();
</script>

<template>
  <div :class="separator ? 'flex flex-col' : 'flex flex-col gap-4'">
    <SearchPassengersTypesRow
      v-model="adults"
      type="adults"
      :minimum="1"
      :maximum="searchCriteria.maxAdults"
    />

    <UiCustomSeparatorLine v-if="separator" />

    <SearchPassengersTypesRow
      v-model="children"
      type="children"
      :minimum="0"
      :maximum="searchCriteria.maxChildren"
    />

    <UiCustomSeparatorLine v-if="separator" />

    <SearchPassengersTypesRow
      v-model="infants"
      type="infants"
      :minimum="0"
      :maximum="searchCriteria.maxInfants"
    />
    <div
      v-if="infants > 0"
      class="py-2 md:px-4"
    >
      <UiAlert variant="info">
        <UiAlertDescription class="text-caption">{{ $t(`${prefix}.infantInfo`) }}</UiAlertDescription>
      </UiAlert>
    </div>
  </div>
</template>
